// extracted by mini-css-extract-plugin
export default {"container":"PromptForm_container__c46KG","error":"PromptForm_error__T-2Kn"};